import React from 'react';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText'; // Asegúrate de importar esto

// Icons
import SentimentVerySatisfied from '@mui/icons-material/SentimentVerySatisfied';
import SentimentSatisfied from '@mui/icons-material/SentimentSatisfied';
import SentimentNeutral from '@mui/icons-material/SentimentNeutral';
import SentimentDissatisfied from '@mui/icons-material/SentimentDissatisfied';
import SentimentVeryDissatisfied from '@mui/icons-material/SentimentVeryDissatisfied';

const ListQuestionsField = ({ source, record = {} }) => {
    const questions = Array.isArray(record[source]) ? record[source] : [];

    return (
        <List>
            {questions.map((item, index) => (
                <ListItem key={index}>
                    <ListItemText
                        primary={item.question}
                        secondary={
                            item.answer === '5' ? 'Excelente' :
                            item.answer === '4' ? 'Muy Bueno' :
                            item.answer === '3' ? 'Bueno' :
                            item.answer === '2' ? 'Regular' :
                            'Malo'
                        }
                    />
                    {item.answer === '5' ? <SentimentVerySatisfied /> :
                        item.answer === '4' ? <SentimentSatisfied /> :
                        item.answer === '3' ? <SentimentNeutral /> :
                        item.answer === '2' ? <SentimentDissatisfied /> :
                        <SentimentVeryDissatisfied />
                    }
                </ListItem>
            ))}
        </List>
    );
};

ListQuestionsField.propTypes = {
    addLabel: PropTypes.bool,
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

ListQuestionsField.defaultProps = {
    addLabel: true,
};

export default ListQuestionsField;
